import type { QueryHookResult } from '@change-corgi/core/react/async';
import { useQuery } from '@change-corgi/core/react/async';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { useCountryCode, useLocale } from 'src/app/shared/hooks/l10n';

import type { SuggestedPetition } from '../../../../shared/api';

import type { Channel } from './api';
import { getSuggestedPetitions } from './api';

type Options = Readonly<{
	petitionSlugOrId?: string;
	channel: Channel;
}>;

export type { Channel };

type SuggestedPetitionsState = QueryHookResult<
	Readonly<{ petitions: readonly SuggestedPetition[]; parentPetitionId?: string }>
>;
type Result = ModelHookResult<{
	petitionsState: SuggestedPetitionsState;
}>;

export function useSuggestedPetitions({ petitionSlugOrId, channel }: Options): Result {
	const locale = useLocale();
	const countryCode = useCountryCode();
	const utilityContext = useUtilityContext();

	return {
		data: {
			petitionsState: useQuery(
				async () => ({
					...(await getSuggestedPetitions({ petitionSlugOrId, locale, countryCode, channel }, utilityContext)),
				}),
				[locale, countryCode, petitionSlugOrId, channel, utilityContext],
			),
		},
	};
}
